import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';

import AuthPage from './Screens/Authpage.tsx';
import Main from './Screens/main.tsx';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { CircularProgress } from '@mui/material';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      setIsLoading(false);
    });
  }, []);

  const handleSignInSuccess = () => {
    localStorage.setItem('authToken', 'true');
    setIsAuthenticated(true);
    navigate('/main'); // Redirect to /main after successful sign-in
  };

  const handleSignOutSuccess = () => {
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
    navigate('/'); // Redirect to / after sign-out
  };

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<AuthPage onSignInSuccess={handleSignInSuccess} />} />
        <Route
          path="/main"
          element={isAuthenticated ? <Main onSignOutSuccess={handleSignOutSuccess} /> : <Navigate to="/" />}
        />
      </Routes>
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}